/**
 * Care Directory JavaScript - Main file for the care directory functionality
 */

document.addEventListener('DOMContentLoaded', function () {
  initRedirectModal();
  initFiltersToggle();
});


function initRedirectModal() {
  if (document.querySelector('.redirect-consent-modal')) {
    return;
  }

  const modal = document.createElement('div');
  modal.id = 'redirect-consent-modal';
  modal.className = 'redirect-consent-modal';
  modal.innerHTML = `
  <div class="redirect-modal-content">
    <span class="close-modal">&times;</span>
    <h2>Ready to leave Versalie and be taken to your selected menopause provider?</h2>
    <p>Kenvue Brands LLC and its affiliates assume no responsibility for interaction with the selected service provider and the Versalie Privacy Notice will no longer apply. We recommend that you verify insurance plan information, as well as the service and treatment options, directly with the service provider prior to scheduling an appointment.</p>
    <div class="modal-buttons">
      <button id="proceed-button" class="btn-primary">Yes, Let's Go</button>
      <button id="stay-button" class="btn-secondary">No, Go Back</button>
    </div>
  </div>
  `;

  document.body.appendChild(modal);

  const closeButton = modal.querySelector('.close-modal');
  const proceedButton = document.getElementById('proceed-button');
  const stayButton = document.getElementById('stay-button');
  let currentUrl = '';

  function handleExternalLinkClick(e) {
    const href = this.getAttribute('href');

    if (href.includes('versalie.com')) {
      return;
    }

    e.preventDefault();
    currentUrl = href;
    modal.style.display = 'flex';
  }

  const serviceLinks = document.querySelectorAll('.care-directory__card-header-button');
  serviceLinks.forEach(link => {
    link.addEventListener('click', handleExternalLinkClick);
  });

  const bannerButton = document.querySelector('.care-directory__banner-button');
  if (bannerButton) {
    bannerButton.addEventListener('click', handleExternalLinkClick);
  }

  function closeModal() {
    modal.style.display = 'none';
  }

  closeButton.addEventListener('click', closeModal);
  stayButton.addEventListener('click', closeModal);

  proceedButton.addEventListener('click', function () {
    if (currentUrl) {
      window.open(currentUrl, '_blank');
    }
    closeModal();
  });

  window.addEventListener('click', function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });
}


function initFiltersToggle() {
  const filterToggleButton = document.querySelector('.care-directory__filters-toggle');
  const filtersContainer = document.querySelector('.care-directory__filters');
  const closeFilterButton = document.querySelector('.care-directory__filters-heading-close');

  if (filterToggleButton && filtersContainer) {
    filterToggleButton.addEventListener('click', function (event) {
      event.preventDefault();
      filtersContainer.classList.toggle('open');
    });
  }

  if (closeFilterButton && filtersContainer) {
    closeFilterButton.addEventListener('click', function () {
      filtersContainer.classList.remove('open');
    });
  }
}

